<page-load-header *ngIf="!initialized"></page-load-header>

<gait-comparison-report [isShared]="true"></gait-comparison-report>


